export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q03_a.1deab42e.png";